import { z } from "zod";

import { canvasFrameSchema, canvasItemSchema } from "./document";

export const canvasSelectionMentionSchema = z
  .object({
    kind: z.literal("canvas-selection"),
    frames: z.array(canvasFrameSchema),
    layerIds: z.array(z.string()).default([]),
    /** Quiz frames (`step`, as HTML), the arrows between them (`edge`) and the campaign they sit in (`section`). */
    items: z.array(canvasItemSchema).default([]),
    source: z
      .object({
        fileId: z.uuid(),
        projectId: z.uuid(),
        name: z.string(),
        fileName: z
          .string()
          .describe(
            "Exact `<title>.canvas.json` filename; what the canvas tools take as the set identifier.",
          ),
      })
      .optional(),
  })
  .describe("CanvasSelectionMention");
